<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbPurchase',
  components: {},
}
</script>
